import { ShieldCheck, FileSearch, History } from "lucide-react";
import heroPerson from "@/assets/hero-person-kontrolle.png";

const KontrolleVisual = () => {
  return (
    <div className="relative w-full h-full min-h-[400px] rounded-2xl overflow-hidden bg-secondary/40">
      {/* Person image - right aligned */}
      <img
        src={heroPerson}
        alt="Service-Mitarbeiter prüft KI-Antwort mit Quellenreferenz"
        className="absolute right-0 top-0 h-full w-[65%] object-cover object-top"
      />

      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-secondary/95 via-secondary/60 to-transparent" />

      {/* Content overlays */}
      <div className="relative z-10 flex flex-col gap-3 p-6 md:p-8 max-w-[280px]">
        {/* Freigabe chip */}
        <div
          className="inline-flex items-center gap-2 bg-background/90 backdrop-blur-sm border border-chathero-mint/30 rounded-full px-3 py-1.5 shadow-sm w-fit animate-fade-in"
          style={{ animationDelay: "0.1s" }}
        >
          <ShieldCheck className="w-3.5 h-3.5 text-chathero-mint" />
          <span className="text-[11px] font-semibold text-foreground">
            Agent: Service · <span className="text-chathero-mint">Freigegeben</span>
          </span>
        </div>

        {/* Bot answer with source badge */}
        <div
          className="bg-background/90 backdrop-blur-sm border border-border rounded-2xl rounded-tl-sm px-4 py-3 shadow-[0_4px_24px_rgba(0,196,180,0.08)] animate-fade-in"
          style={{ animationDelay: "0.4s" }}
        >
          <p className="text-sm text-foreground font-medium leading-snug mb-2.5">
            Basierend auf Ihrem Vertrag empfehle ich die erweiterte Wartungsoption.
          </p>
          {/* Source reference badge */}
          <div className="flex items-center gap-1.5 bg-chathero-mint/10 border border-chathero-mint/20 rounded-full px-2.5 py-1 w-fit">
            <FileSearch className="w-3 h-3 text-chathero-mint" />
            <span className="text-[10px] font-semibold text-chathero-mint">
              Quelle: Prozesshandbuch v3.2
            </span>
          </div>
        </div>

        {/* Version info */}
        <div
          className="flex items-center gap-2 bg-background/80 backdrop-blur-sm border border-border rounded-xl px-3 py-2 shadow-sm animate-fade-in"
          style={{ animationDelay: "0.7s" }}
        >
          <History className="w-3.5 h-3.5 text-muted-foreground" />
          <span className="text-[11px] text-muted-foreground">
            Zuletzt aktualisiert: M. Weber · 14:32
          </span>
        </div>
      </div>
    </div>
  );
};

export default KontrolleVisual;
